import React from 'react';
import EditEventForm from '../events/EditEventForm';

function EditEventPopup({ event, onClose, onSuccess }) {
  return (
    <div className="edit-event-popup-content">
      <EditEventForm event={event} onClose={onClose} onSuccess={onSuccess} />
    </div>
  );
}

export default EditEventPopup;
